/* ============================================================
   SNOVA front-end engine (V3) — vanilla, no deps.
   window.SNOVA api + 'snova:*' events.

   PORTED from snova_v3.html. Key V3 change: CURRENCY IS REAL.
   The currency control now sets Shopify's PRESENTMENT currency by
   POSTing the hidden /localization form (see layout/theme.liquid),
   so Shopify re-renders all | money prices in the real checkout
   currency — NOT a display-only JS conversion, and nothing is
   "charged in JPY". The optional JS conversion remains only as a
   fallback for any JPY-anchored static [data-price-jpy] node before
   Shopify re-renders.

   Kept intact: fade-in reveal,
   sticky ATC, theme toggle, AJAX add-to-cart with tier
   line-item properties, tiny hero parallax. BOTH attribute aliases
   are bound (data-snova-currency / data-currency-select;
   data-snova-plan radios / data-purchase-toggle+data-purchase-mode;
   data-snova-atc / data-atc-form).
   ============================================================ */
(function(){
  'use strict';
  var doc = document, root = doc.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- Static display anchor rates (per 1 JPY). Fallback only — real prices
  //      come from Shopify presentment currency once selected. ----
  var DEFAULT_RATES = { GBP:0.0053, USD:0.0067, AUD:0.0098, JPY:1 };
  var SYMBOLS = { GBP:'£', USD:'$', AUD:'A$', AED:'د.إ ', JPY:'¥', EUR:'€', CAD:'C$', SGD:'S$' };
  var rates = (window.SNOVA_RATES && typeof window.SNOVA_RATES === 'object') ? window.SNOVA_RATES : DEFAULT_RATES;
  var SUB_DISCOUNT = 0.15;

  function readStored(key, fallback){ try{ var v = localStorage.getItem(key); return v == null ? fallback : v; }catch(e){ return fallback; } }
  function store(key, val){ try{ localStorage.setItem(key, val); }catch(e){} }

  // =================== CURRENCY (REAL presentment) ===================
  // Active currency = Shopify's current cart/presentment currency (written by
  // the layout). A shopper's STORED choice is honored ONLY while a currency
  // switcher exists on the page. On a single-currency store (no switcher, e.g.
  // the USD-only launch) a stale stored choice from an earlier visit must NOT
  // repaint static anchors in a currency the store no longer serves (this bug
  // showed one tier as 10,377 yen amid USD prices). (2026-07-06.)
  var activeCur = (window.SNOVA_ACTIVE_CURRENCY && String(window.SNOVA_ACTIVE_CURRENCY)) || 'USD';
  var hasSwitcher = !!doc.querySelector('[data-snova-currency], .curr-switch button[data-curr], select[data-currency-select]');
  var storedCur = readStored('snova-currency', null);
  if (!hasSwitcher && storedCur && storedCur !== activeCur) {
    try { localStorage.removeItem('snova-currency'); } catch (e) {}
    storedCur = null;
  }
  var currency = (hasSwitcher && storedCur) || activeCur;

  function formatPrice(jpy, code){
    code = code || currency;
    var rate = rates[code] != null ? rates[code] : (DEFAULT_RATES[code] != null ? DEFAULT_RATES[code] : 1);
    var val = jpy * rate;
    var sym = SYMBOLS[code] || (code + ' ');
    return sym + Math.round(val).toLocaleString('en-GB');
  }

  // Repaint any JPY-anchored static node (fallback only). When Shopify has
  // re-rendered | money prices these nodes are absent, so this is a no-op.
  function renderPrices(){
    doc.querySelectorAll('[data-price-jpy]').forEach(function(el){
      var jpy = parseFloat(el.getAttribute('data-price-jpy'));
      if(isNaN(jpy)) return;
      var isSub = el.hasAttribute('data-price-sub') && plan === 'subscribe';
      var factor = isSub ? (1 - SUB_DISCOUNT) : 1;
      var orig = el.querySelector('[data-price-original]');
      var target = el.querySelector('[data-price-value]');
      var text = formatPrice(jpy * factor, currency);
      if(target){ target.textContent = text; } else if(!orig){ el.textContent = text; }
      else {
        var valSpan = el.querySelector('[data-price-now]');
        if(!valSpan){ valSpan = doc.createElement('span'); valSpan.setAttribute('data-price-now',''); el.appendChild(valSpan); }
        valSpan.textContent = text;
      }
      if(orig){ orig.textContent = isSub ? formatPrice(jpy, currency) : ''; }
    });
    doc.querySelectorAll('[data-currency-symbol]').forEach(function(s){ s.textContent = SYMBOLS[currency] || ''; });
    doc.querySelectorAll('[data-currency-code]').forEach(function(s){ s.textContent = currency; });
  }

  // Set the REAL presentment currency by submitting the hidden localization form.
  // Shopify reloads the page rendering all | money prices in `code`.
  function setCurrency(code){
    if(!code) return;
    code = String(code).toUpperCase();
    if(code === currency){ // already active — just sync controls
      syncCurrencyControls(code);
      return;
    }
    store('snova-currency', code);
    var form = doc.getElementById('snova-localization-form');
    var input = doc.getElementById('snova-currency-input');
    if(form && input){
      input.value = code;
      // reflect immediately, then submit (page reloads with real prices)
      syncCurrencyControls(code);
      doc.dispatchEvent(new CustomEvent('snova:currency', { detail:{ currency: code } }));
      try{ form.submit(); return; }catch(e){}
    }
    // Fallback (no form): repaint static anchors only.
    currency = code;
    syncCurrencyControls(code);
    renderPrices();
    doc.dispatchEvent(new CustomEvent('snova:currency', { detail:{ currency: code } }));
  }

  function syncCurrencyControls(code){
    doc.querySelectorAll('[data-snova-currency]').forEach(function(ctrl){
      if(ctrl.tagName === 'SELECT'){ ctrl.value = code; }
      else { ctrl.classList.toggle('is-active', ctrl.getAttribute('data-snova-currency') === code); }
    });
    doc.querySelectorAll('select[data-currency-select]').forEach(function(sel){ sel.value = code; });
    doc.querySelectorAll('.curr-switch button[data-curr]').forEach(function(b){
      b.classList.toggle('active', b.getAttribute('data-curr') === code);
    });
  }

  function bindCurrency(){
    // Primary control: header <select data-snova-currency> (real presentment).
    doc.querySelectorAll('[data-snova-currency]').forEach(function(ctrl){
      if(ctrl.tagName === 'SELECT'){
        ctrl.addEventListener('change', function(){ setCurrency(this.value); });
      } else {
        ctrl.addEventListener('click', function(){ setCurrency(this.getAttribute('data-snova-currency')); });
      }
    });
    // Compat alias: pricing section uses <select data-currency-select>.
    doc.querySelectorAll('select[data-currency-select]').forEach(function(sel){
      sel.addEventListener('change', function(){ setCurrency(this.value); });
    });
    // Compat alias: twin-style segmented .curr-switch button[data-curr].
    doc.querySelectorAll('.curr-switch').forEach(function(group){
      group.addEventListener('click', function(e){
        var b = e.target.closest('button[data-curr]');
        if(!b) return;
        setCurrency(b.getAttribute('data-curr'));
      });
    });
    syncCurrencyControls(currency);
    pinUsdOnce();
  }

  // Page is USD-basis: if Shopify's real presentment currency loaded as anything
  // other than USD (e.g. JPY for a JP-market visitor) AND the shopper has not
  // manually chosen a currency, switch presentment to USD one time so prices read
  // in $ above the fold. Guarded by a per-tab session flag so the localization
  // reload never loops, and skipped entirely if the shopper picked a currency.
  function pinUsdOnce(){
    try{
      var chosen = readStored('snova-currency', null);      // shopper's explicit pick
      if(chosen){ return; }                                  // respect their choice
      var active = (window.SNOVA_ACTIVE_CURRENCY && String(window.SNOVA_ACTIVE_CURRENCY).toUpperCase()) || '';
      if(active === 'USD'){ return; }                        // already USD, nothing to do
      var TRIED = 'snova-usd-pin-tried';
      if(sessionStorage.getItem(TRIED)){ return; }           // already attempted this tab
      sessionStorage.setItem(TRIED, '1');
      var form = doc.getElementById('snova-localization-form');
      var input = doc.getElementById('snova-currency-input');
      if(form && input){
        input.value = 'USD';
        // A currency is only accepted for a country whose Shopify market enables it.
        // If the visitor's market is JPY-only, currency_code=USD alone is ignored, so
        // also set the country to US (a USD market) to guarantee $ resolves. Shipping/
        // tax context then reads US until the shopper picks their own country.
        var cc = form.querySelector('input[name="country_code"]');
        if(cc){ cc.value = 'US'; }
        form.submit();                                       // reloads with $ prices
      }
    }catch(e){ /* sessionStorage blocked or no form: leave presentment as-is */ }
  }

  // =================== PURCHASE PLAN / PRE-ENROLL ===================
  var plan = 'onetime'; // one-time default (recurring billing not live yet)

  function applyPlanUI(){
    doc.querySelectorAll('.snova-plan').forEach(function(label){
      var input = label.querySelector('.snova-plan__radio');
      label.classList.toggle('is-selected', !!(input && input.checked));
    });
    doc.querySelectorAll('[data-sub-only]').forEach(function(el){
      if(plan === 'subscribe'){ el.hidden = false; el.style.display = ''; }
      else { el.hidden = true; el.style.display = 'none'; }
    });
    doc.querySelectorAll('[data-onetime-only]').forEach(function(el){
      if(plan === 'onetime'){ el.hidden = false; el.style.display = ''; }
      else { el.hidden = true; el.style.display = 'none'; }
    });
    // twin-style explainer note + pill toggle
    doc.querySelectorAll('#preNote,[data-preenroll-note]').forEach(function(n){ n.classList.toggle('show', plan === 'subscribe'); });
    doc.querySelectorAll('[data-purchase-toggle] [data-purchase-mode]').forEach(function(btn){
      var on = btn.getAttribute('data-purchase-mode') === plan;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    doc.querySelectorAll('button.toggle[id="preToggle"],[data-preenroll-pill]').forEach(function(p){
      p.setAttribute('aria-pressed', String(plan === 'subscribe'));
    });
  }

  function setPlan(mode){
    plan = (mode === 'subscribe') ? 'subscribe' : 'onetime';
    doc.querySelectorAll('.snova-plan__radio').forEach(function(input){
      if(input.value === plan && !input.checked){ input.checked = true; }
    });
    applyPlanUI();
    renderPrices();
    // emit both event names the sections listen for
    doc.dispatchEvent(new CustomEvent('snova:plan', { detail:{ plan: plan } }));
    doc.dispatchEvent(new CustomEvent('snova:purchase-mode', { detail:{ mode: plan } }));
  }
  // alias used by pricing section
  function setMode(mode){ setPlan(mode); }

  function bindPlan(){
    // radio-card form
    doc.querySelectorAll('fieldset[data-snova-plan] .snova-plan__radio').forEach(function(input){
      input.addEventListener('change', function(){ if(this.checked) setPlan(this.value); });
    });
    // segmented control [data-purchase-toggle] > [data-purchase-mode]
    doc.querySelectorAll('[data-purchase-toggle] [data-purchase-mode]').forEach(function(btn){
      btn.addEventListener('click', function(){ setPlan(this.getAttribute('data-purchase-mode')); });
    });
    // twin-style single pill toggle (#preToggle / [data-preenroll-pill])
    doc.querySelectorAll('button.toggle[id="preToggle"],[data-preenroll-pill]').forEach(function(p){
      p.addEventListener('click', function(){ setPlan(plan === 'subscribe' ? 'onetime' : 'subscribe'); });
    });
    var checked = doc.querySelector('fieldset[data-snova-plan] .snova-plan__radio:checked');
    plan = (checked && checked.value === 'subscribe') ? 'subscribe' : 'onetime';
    applyPlanUI();
  }

  // =================== CART ===================
  function refreshCart(){
    return fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        doc.querySelectorAll('[data-cart-count]').forEach(function(c){ c.textContent = cart.item_count; });
        renderDrawer(cart);
        doc.dispatchEvent(new CustomEvent('snova:cart', { detail:{ cart: cart } }));
        return cart;
      }).catch(function(){});
  }

  function renderDrawer(cart){
    var body = doc.querySelector('[data-cart-drawer-body]');
    if(!body) return;
    if(!cart || !cart.items || !cart.items.length){
      body.innerHTML = '<p class="snova-foot-note">Your bag is empty.</p>';
      return;
    }
    var html = '';
    cart.items.forEach(function(it){
      var props = '';
      if(it.properties){
        Object.keys(it.properties).forEach(function(k){
          if(k.charAt(0) === '_') return;
          props += '<div class="snova-drawer-item__prop">' + k + ': ' + it.properties[k] + '</div>';
        });
      }
      html += '<div class="snova-drawer-item">' +
        (it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : '') +
        '<div class="snova-drawer-item__meta">' +
          '<div class="snova-drawer-item__title">' + it.product_title + ' × ' + it.quantity + '</div>' +
          props +
        '</div></div>';
    });
    body.innerHTML = html;
  }

  function openCart(){ var d = doc.getElementById('snova-cart-drawer'); if(d){ d.classList.add('is-open'); d.setAttribute('aria-hidden','false'); } }
  function closeCart(){ var d = doc.getElementById('snova-cart-drawer'); if(d){ d.classList.remove('is-open'); d.setAttribute('aria-hidden','true'); } }

  function buildProperties(extra){
    // Refills/pre-enrolment property removed 2026-07-06: the store ships from
    // inventory, there is no enrolment, and orders must not carry the property.
    return extra || {};
  }

  function addToCart(opts){
    var payload = {
      items:[{ id: opts.id, quantity: opts.quantity || 1, properties: buildProperties(opts.properties) }]
    };
    return fetch('/cart/add.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify(payload)
    }).then(function(r){ return r.json(); })
      .then(function(res){ return refreshCart().then(function(){ openCart(); return res; }); })
      .catch(function(err){ console.error('SNOVA add-to-cart failed', err); });
  }

  function bindForms(){
    // contract hook (form[data-snova-atc]) + pricing compat hook (form[data-atc-form])
    doc.querySelectorAll('form[data-snova-atc], form[data-atc-form]').forEach(function(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var variantId = form.getAttribute('data-variant-id') || (form.querySelector('[name="id"]') && form.querySelector('[name="id"]').value);
        if(!variantId) return;
        var qty = parseInt(form.getAttribute('data-quantity') || (form.querySelector('[name="quantity"]') && form.querySelector('[name="quantity"]').value) || '1', 10);
        var tier = form.getAttribute('data-tier') || (btn && btn.getAttribute('data-tier')) || '';
        var extra = {}; if(tier) extra['Tier'] = tier;
        if(btn){ btn.disabled = true; btn.classList.add('is-loading'); }
        addToCart({ id: variantId, quantity: qty, properties: extra }).then(function(){
          if(btn){ btn.disabled = false; btn.classList.remove('is-loading'); }
        });
      });
    });
    doc.querySelectorAll('[data-cart-open]').forEach(function(b){ b.addEventListener('click', function(){ openCart(); refreshCart(); }); });
    doc.querySelectorAll('[data-cart-close],[data-cart-overlay]').forEach(function(b){ b.addEventListener('click', closeCart); });
    doc.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeCart(); });
  }

  // =================== STICKY ATC ===================
  function bindSticky(){
    var sticky = doc.getElementById('snova-sticky-atc') || doc.querySelector('.snova-sticky');
    if(!sticky) return;
    var heroSentinel = doc.querySelector('[data-hero-sentinel]');
    var pricingSentinel = doc.querySelector('[data-pricing-sentinel]');
    var heroVisible = !!heroSentinel;
    var pricingVisible = false;

    function update(){ sticky.classList.toggle('is-visible', !heroVisible && !pricingVisible); }
    if('IntersectionObserver' in window){
      if(heroSentinel){
        new IntersectionObserver(function(ents){ heroVisible = ents[0].isIntersecting; update(); }, { threshold:0 }).observe(heroSentinel);
      } else { heroVisible = false; }
      if(pricingSentinel){
        new IntersectionObserver(function(ents){ pricingVisible = ents[0].isIntersecting; update(); }, { threshold:0.5 }).observe(pricingSentinel);
      }
    } else { sticky.classList.add('is-visible'); }
    update();

    var btn = sticky.querySelector('[data-sticky-atc-btn]');
    if(btn){
      btn.addEventListener('click', function(){
        var variantId = btn.getAttribute('data-sticky-variant') || (sticky.querySelector('[data-sticky-variant]') && sticky.querySelector('[data-sticky-variant]').getAttribute('data-sticky-variant'));
        var tier = btn.getAttribute('data-tier') || '';
        if(!variantId) return;
        btn.disabled = true; btn.classList.add('is-loading');
        addToCart({ id: variantId, quantity:1, properties: tier ? { Tier: tier } : {} }).then(function(){ btn.disabled = false; btn.classList.remove('is-loading'); });
      });
    }
  }

  // =================== THEME ===================
  function setTheme(t){
    t = (t === 'dark') ? 'dark' : 'light';
    root.setAttribute('data-theme', t);
    store('snova-theme', t);
    var m = doc.querySelector('meta[name="theme-color"]');
    if(m) m.setAttribute('content', t === 'dark' ? '#16130F' : '#FBFAF7');
    // re-measure any open FAQ answer after palette change
    var open = doc.querySelector('.faq-item.open .faq-a');
    if(open){ open.style.maxHeight = open.scrollHeight + 'px'; }
  }
  function toggleTheme(){ setTheme(root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark'); }
  function bindTheme(){ doc.querySelectorAll('[data-theme-toggle]').forEach(function(b){ b.addEventListener('click', toggleTheme); }); }

  // =================== REVEAL + PARALLAX ===================
  function bindReveal(){
    var sel = '.snova-reveal, .reveal-up, .ing-img.reveal, .evidence';
    var els = doc.querySelectorAll(sel);
    function revealAll(){ els.forEach(function(el){ el.classList.add('is-visible'); el.classList.add('in'); }); }
    if(reduceMotion || !('IntersectionObserver' in window)){ revealAll(); return; }
    doc.querySelectorAll('[data-reveal-stagger]').forEach(function(parent){
      var kids = parent.querySelectorAll(':scope > .snova-reveal');
      kids.forEach(function(k, i){ k.style.setProperty('--reveal-delay', (i * 80) + 'ms'); });
    });
    var io = new IntersectionObserver(function(ents){
      ents.forEach(function(ent){ if(ent.isIntersecting){ ent.target.classList.add('is-visible'); ent.target.classList.add('in'); io.unobserve(ent.target); } });
    }, { threshold:0.14, rootMargin:'0px 0px -8% 0px' });
    els.forEach(function(el){ io.observe(el); });
    // safety net: nothing stays hidden after load
    window.addEventListener('load', function(){ setTimeout(revealAll, 1200); });
  }

  function bindParallax(){
    if(reduceMotion) return;
    var items = doc.querySelectorAll('[data-parallax], #heroBottle, [data-hero-bottle]');
    if(!items.length) return;
    var ticking = false;
    function frame(){
      var y = window.scrollY || window.pageYOffset;
      items.forEach(function(el){
        var max = parseFloat(el.getAttribute('data-parallax')) || 24;
        if(max > 24) max = 24;
        var shift = Math.max(-max, Math.min(0, -y * 0.05));
        el.style.transform = 'translateY(' + shift.toFixed(1) + 'px)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function(){ if(!ticking){ ticking = true; requestAnimationFrame(frame); } }, { passive:true });
    frame();
  }

  // =================== FAQ ACCORDION ===================
  function bindFaq(){
    function syncOpen(){
      doc.querySelectorAll('.faq-item.open').forEach(function(item){
        var a = item.querySelector('.faq-a');
        if(a){ a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    }
    syncOpen();
    window.addEventListener('load', syncOpen);
    doc.querySelectorAll('.faq-item').forEach(function(item){
      var q = item.querySelector('.faq-q'); var a = item.querySelector('.faq-a');
      if(!q || !a) return;
      q.addEventListener('click', function(){
        var isOpen = item.classList.contains('open');
        doc.querySelectorAll('.faq-item.open').forEach(function(o){ if(o!==item){ o.classList.remove('open'); var oa=o.querySelector('.faq-a'); if(oa) oa.style.maxHeight = null; } });
        if(isOpen){ item.classList.remove('open'); a.style.maxHeight = null; }
        else { item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
  }

  // =================== INIT ===================
  function init(){
    bindCurrency();
    bindPlan();
    bindForms();
    bindSticky();
    bindTheme();
    bindReveal();
    bindParallax();
    bindFaq();
    renderPrices();
    refreshCart();
  }
  if(doc.readyState === 'loading'){ doc.addEventListener('DOMContentLoaded', init); } else { init(); }

  // =================== PUBLIC API ===================
  window.SNOVA = {
    get currency(){ return currency; },
    rates: rates,
    setCurrency: setCurrency,
    formatPrice: formatPrice,
    renderPrices: renderPrices,
    get plan(){ return plan; },
    mode: function(){ return plan; },
    setPlan: setPlan,
    setMode: setMode,
    subDiscount: SUB_DISCOUNT,
    addToCart: addToCart,
    openCart: openCart,
    closeCart: closeCart,
    refreshCart: refreshCart,
    toggleTheme: toggleTheme,
    setTheme: setTheme
  };
})();
